export default "__VITE_ASSET__jdotqn2A__"